import type {
  AgentExamPayload,
  AgentLicensing,
  AgentOnboarding,
  AgentOnboardingItemPayload,
  AgentSelectItem,
  OnboardingItemKey,
} from "@/types/agent";
import { apiClient } from "./client";

export const agentsApi = {
  getAgentsForSelect() {
    return apiClient.get<AgentSelectItem[]>("/agents/select");
  },

  getLicensing(agentId: string) {
    return apiClient.get<AgentLicensing>(`/api/agents/${agentId}/licensing`);
  },

  setAuthorizations(agentId: string, insurerIds: string[]) {
    return apiClient.put<AgentLicensing>(
      `/api/agents/${agentId}/authorizations`,
      { insurerIds },
    );
  },

  setExam(agentId: string, { insurerId, ...exam }: AgentExamPayload) {
    return apiClient.put<AgentLicensing>(
      `/api/agents/${agentId}/exams/${insurerId}`,
      exam,
    );
  },

  clearExam(agentId: string, insurerId: string) {
    return apiClient.delete<AgentLicensing>(
      `/api/agents/${agentId}/exams/${insurerId}`,
    );
  },

  getOnboarding(agentId: string) {
    return apiClient.get<AgentOnboarding>(`/api/agents/${agentId}/onboarding`);
  },

  setOnboardingItem(
    agentId: string,
    key: OnboardingItemKey,
    payload: AgentOnboardingItemPayload,
  ) {
    return apiClient.put<AgentOnboarding>(
      `/api/agents/${agentId}/onboarding/${key}`,
      payload,
    );
  },
};
